export const GET_INVOICES = 'GET_INVOICES'

export const POST_DISREGARD_INVOICE = 'POST_DISREGARD_INVOICE'
export const POST_DISREGARD_INVOICE_FULFILLED = 'POST_DISREGARD_INVOICE_FULFILLED'
export const POST_DISREGARD_INVOICE_RESET = 'POST_DISREGARD_INVOICE_RESET'

export const GET_CREDITS = 'GET_CREDITS'

export const GET_REFUNDS = 'GET_REFUNDS'
